import { createFileRoute, Outlet } from "@tanstack/react-router";

function CatalogacionLayout() {
  return <Outlet />;
}

/** Layout: hijos en index, precios, importar (marcas → /app/marcas). */
export const Route = createFileRoute("/app/catalogacion")({
  component: CatalogacionLayout,
});
